<div class="jumper-holder" [ngClass]="{'jumper-xs': config?.extraSmall}">
  @if (config === null || config.showAnyJumper !== false) {
    <table>
      <tr>
        <td>
          <button
            type="button"
            class="btn btn-success btn-sm"
            (click)="next($event)"
            (keydown.enter)="next($event)"
            title="jump to newer">
            <i class="fa fa-chevron-up"></i>
          </button>
        </td>
        <td>
          <button
            type="button"
            class="btn btn-success btn-sm"
            (click)="previous($event)"
            (keydown.enter)="previous($event)"
            title="jump to older">
            <i class="fa fa-chevron-down"></i>
          </button>
        </td>
      </tr>
    </table>
  }

  @if (config === null || config.showTypeJumper !== false) {
    <table>
      <tr>
        @if (config?.showLabels) {
          <td>&nbsp;&nbsp;By type:</td>
        }
        <td>
          <button
            type="button"
            class="btn btn-info btn-sm"
            (click)="nextOfType($event)"
            (keydown.enter)="nextOfType($event)"
            title="jump to newer of this type">
            <i class="fa fa-chevron-up"></i>
          </button>
        </td>
        <td>
          <button
            type="button"
            class="btn btn-info btn-sm"
            (click)="previousOfType($event)"
            (keydown.enter)="previousOfType($event)"
            title="jump to older of this type">
            <i class="fa fa-chevron-down"></i>
          </button>
        </td>
      </tr>
    </table>
  }

  @if (config === null || config.showBootJumper !== false) {
    <table>
      <tr>
        @if (config?.showLabels) {
          <td>&nbsp;&nbsp;Boot:</td>
        }
        <td>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            (click)="nextBoot($event)"
            (keydown.enter)="nextBoot($event)"
            title="jump to newer boot">
            <i class="fa fa-chevron-up"></i>
          </button>
        </td>
        <td>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            (click)="previousBoot($event)"
            (keydown.enter)="previousBoot($event)"
            title="jump to older boot">
            <i class="fa fa-chevron-down"></i>
          </button>
        </td>
      </tr>
    </table>
  }
</div>
